import { styled } from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import { CenteredWrapper } from "../styles";

export const LegendContainer = styled(Flex)`
    box-sizing: border-box;
    margin-bottom: 16px;
    margin-top: 16px;
`;

export const StyledWrapper = styled(CenteredWrapper)`
    margin-right: 16px;
`;

export const ButtonContainer = styled.div`
    margin-left: auto;
`;
